import { css } from '@emotion/react';
import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import { CachedAudioScrubber } from '@frontend/phone-panels';
import { theme } from '@frontend/theme';

type Props = {
  call: HydratedCallRecord;
  callRecordingPath: string;
};

export const CallRecordingSection = ({ call, callRecordingPath }: Props) => {
  return (
    <div css={styles.wrapper}>
      <CachedAudioScrubber filePath={callRecordingPath} mediaId={call?.channelId || ''} />
    </div>
  );
};

const styles = {
  wrapper: css`
    button {
      min-width: ${theme.spacing(3)};
      width: ${theme.spacing(3)};
      height: ${theme.spacing(3)};
      padding: ${theme.spacing(0)};
    }
  `,
};
